import React from "react";
import Head from "../layout/head.jsx";
import Content from "../layout/content.jsx";
import Form from "../layout/form.jsx";
import API from "../../services/api.jsx";
import { toast } from "react-toastify";
import Loader from "../layout/loader.jsx";
import i18n from "../../services/i18n.jsx";

class ChangePassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      breadcrumb: {
        title: "back to Account",
        path: "/account"
      },
      fields: {
        oldPassword: {
            placeholder: "Enter password",
            label: "Current password",
            type: "password",
            disabledValidation: true,
            required: true
        },
        newPassword: { 
            placeholder: "Enter password",
            label: "New password",
            type: "password",
            required: true,
            errorMessage: i18n.t("PASSWORD_RULE")
        },
        confirmPassword: {
            placeholder: "Enter password",
            label: "Confirm password",
            type: "password",
            required: true,
            errorMessage: i18n.t("PASSWORD_RULE")
        },
      },
      changepassword: {},
    };
    this.saveEntity = this.saveEntity.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  saveEntity(fields) {
    if(fields.confirmPassword !== fields.newPassword){
        toast.error("Password and confirmation password do not match.");
        return;
    }

    const params = {
        oldPassword: fields.oldPassword,
        newPassword: fields.newPassword,
    }

    this.setState({ loading: true });
    API.changePassword(params)
      .then(() => {
        toast.success("Your password has been updated");
        this.props.history.push("/account");
      })
      .catch(() => {
        // toast.error("An unexpected error has occurred, please try again");
        this.setState({ loading: false });
      });
  }

  cancel() {
    this.props.history.push('/account')
  }

  render() {
    if(this.state.loading) return <Loader />
    else
      return (
        <>
          <Head
            title="Change password"
            breadcrumb={this.state.breadcrumb}
          />
          <Content>
            <Form
              hideTitle={true}
              fields={this.state.fields}
              entity={this.state.changepassword}
              cancel={this.cancel}
              save={this.saveEntity}
            />
          </Content>
        </>
      );
  }
}

export default ChangePassword;
